import { format, isValid, parseISO } from 'date-fns';

/** `silvana@gmail.com` → `s*****a@gmail.com`: primeira e última letra do usuário e o domínio. */
export function maskRenewalEmail(email: string | null | undefined): string {
  const trimmed = (email ?? '').trim();
  const at = trimmed.lastIndexOf('@');
  if (at <= 0 || at === trimmed.length - 1) return '';
  const user = trimmed.slice(0, at);
  const domain = trimmed.slice(at);
  if (user.length === 1) return `${user}${domain}`;
  if (user.length === 2) return `${user[0]}*${domain}`;
  return `${user[0]}${'*'.repeat(user.length - 2)}${user[user.length - 1]}${domain}`;
}

/** `21999990022` → `(21) *****-**22`: DDD e os 2 últimos dígitos. Sem telefone utilizável, `''`. */
export function maskRenewalPhone(phone: string | null | undefined): string {
  let digits = (phone ?? '').replace(/\D/g, '');
  if (digits.length > 11 && digits.startsWith('55')) digits = digits.slice(2);
  if (digits.length !== 10 && digits.length !== 11) return '';
  const prefixMask = '*'.repeat(digits.length - 6);
  return `(${digits.slice(0, 2)}) ${prefixMask}-**${digits.slice(-2)}`;
}

function formatDate(value: string): string {
  const date = parseISO(value);
  return isValid(date) ? format(date, 'dd/MM/yyyy') : '—';
}

/** Vigência do contrato no formato do Figma: `05/10/2025 até 05/10/2026`. */
export function formatRenewalPeriod(startAt: string, endAt: string): string {
  return `${formatDate(startAt)} até ${formatDate(endAt)}`;
}
